import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Changelog from '../components/Changelog';

const ChangelogPage = () => {
  return (
    <div className="changelog-page">
      <div className="page-content">
        {/* The changelog itself sits in a centred `.container`; the back
            link must share that column or it lands on the far left edge
            of a wide screen, a whole viewport away from the page. */}
        <div className="container page-navigation">
          <Link to="/" className="back-link">
            <ArrowLeft size={18} />
            Back to Home
          </Link>
        </div>

        <Changelog />
      </div>
    </div>
  );
};

export default ChangelogPage;
